import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_EVENTS,
    FAILURE_EVENT_LANGUAGES,
    REQUEST_EVENTS,
    REQUEST_EVENT_LANGUAGES,
    SUCCESS_EVENTS,
    SUCCESS_EVENT_LANGUAGES,
} from 'src/store/event/actions';

/* Events */
export function eventsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_EVENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENTS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Event Languages */
export function eventLanguagesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_EVENT_LANGUAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EVENT_LANGUAGES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_EVENT_LANGUAGES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
